import { Prefs } from "~/alias/prefs";
import ServerMessages from "~/servermessages";
import { getMatchingDomain } from "./shared";
const requestFilter = {
    urls: [],
};
function getOriginDomain(details) {
    var _a, _b;
    const url = (_b = (_a = details.initiator) !== null && _a !== void 0 ? _a : details.documentUrl) !== null && _b !== void 0 ? _b : details.originUrl;
    if (!url) {
        return null;
    }
    return new URL(url).hostname;
}
async function recordRequestCreated(originDomain) {
    const domain = await getMatchingDomain(originDomain);
    if (!domain) {
        return;
    }
    ServerMessages.recordAnonymousMessage("request_created", "stats", null, {
        misc_text: domain,
    });
}
async function recordRequestCompleted(originDomain) {
    const domain = await getMatchingDomain(originDomain);
    if (!domain) {
        return;
    }
    ServerMessages.recordAnonymousMessage("request_completed", "stats", null, {
        misc_text: domain,
    });
}
async function recordRequestFailed(originDomain, error) {
    const domain = await getMatchingDomain(originDomain);
    if (!domain) {
        return;
    }
    ServerMessages.recordAnonymousMessage("request_failed", "stats", null, {
        error_msg: error,
        misc_text: domain,
    });
}
export async function start() {
    await Prefs.untilLoaded;
    requestFilter.urls = Prefs.get("pageviewMetrics_requestUrls");
    browser.webRequest.onBeforeRequest.addListener((details) => {
        const originDomain = getOriginDomain(details);
        void recordRequestCreated(originDomain);
        return {};
    }, requestFilter);
    browser.webRequest.onCompleted.addListener((details) => {
        const originDomain = getOriginDomain(details);
        if (details.statusCode >= 400 && details.statusCode <= 599) {
            void recordRequestFailed(originDomain, `HTTP ${details.statusCode}`);
            return;
        }
        void recordRequestCompleted(originDomain);
    }, requestFilter);
    browser.webRequest.onErrorOccurred.addListener((details) => {
        const originDomain = getOriginDomain(details);
        void recordRequestFailed(originDomain, details.error);
    }, requestFilter);
}
